import {
  Actions as SummaryActions,
  type SummaryAction,
} from 'src/components/Profile/Summary/actions';
import { ADD, EDIT } from 'src/consts';
import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';
import { getDataFromCache } from 'src/modules/apollo/apolloCache';
import type { Action, ApiClient } from 'src/types';
import { GetCareerObjectivesDocument } from 'src/types/graphql';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const createPersonalSummaryAnalyticsMiddleware = (
  analytics: Analytics,
  { apolloClient }: ApiClient,
) =>
  instrumentAnalytics(analytics) &&
  (() => (next: (action: Action) => void) => (action: SummaryAction) => {
    const { updateCard } = analytics;

    switch (action.type) {
      case SummaryActions.SUMMARY_UPDATE_START: {
        const { newSummary } = action.payload;

        const careerObjectivesData = getDataFromCache({
          cache: apolloClient.cache,
          query: GetCareerObjectivesDocument,
        });
        const currentSummary =
          careerObjectivesData?.viewer?.careerObjectives?.personalStatement ||
          null;

        const hasSummary = Boolean(currentSummary);

        if (newSummary !== currentSummary) {
          const actionName = hasSummary ? EDIT : ADD;
          updateCard({
            actionName,
            currentPageSection: 'personal summary',
          });
        }
        break;
      }

      default: {
        break;
      }
    }

    return next(action);
  });
